import { Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { checkUsertoken } from "../../../redux/features/login/login";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization";
import { deleteDevice } from "../../../redux/features/devices/devices";

const DeleteDevicePopup = ({ close, deviceId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDeleteDevice = async (id) => {
    dispatch(checkUsertoken());
    try {
      const response = await dispatch(deleteDevice(id));

      if (response.payload.status === true) {
        navigate("/settings/Devices", {
          state: {
            isDeviceDeleted: true,
          },
        });
      } else {
        toast.error(response.payload.errors.base[0], toast_position);
      }
    } catch (err) {
      (() => {})();
      toast.error("Failed To delete!", toast_position);
    } finally {
      close(false);
    }
  };

  return (
    <>
      <div className="fixed w-screen h-screen top-0 left-0 z-[9998] bg-custom-backdrop opacity-80"></div>
      <div
        className="fixed top-1/2 left-1/2 z-[9999] p-3 flex justify-center items-center w-full"
        style={{ transform: "translate(-50%, -50%)" }}
      >
        <div className="w-full max-w-[400px] bg-custom-appBackLight rounded-2xl p-4 flex flex-col gap-4">
          <div className="px-2">
            <h6 className="text-custom-orange font-semibold md:font-bold pb-1">
              Delete Device
            </h6>
            <div className="mb-3">
              <span className="text-white text-sm break-words">
                Are you sure, you want to delete this device?
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "6%",
                margin: "0px 50px",
                width: "100%",
              }}
              className="px-4 pt-4 m-4"
            >
              <Button
                onClick={() => {
                  close(false);
                }}
                sx={{
                  borderColor: "none",
                  color: "var(--Primary_white)",
                  textTransform: "capitalize",
                  textDecoration: "underline",
                  fontFamily:
                    '-apple-system, "Open Sans", sans-serif !important',
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => handleDeleteDevice(deviceId)}
                sx={{
                  borderRadius: "20px",
                  color: "var(--Primary_white) !important",
                  textTransform: "capitalize",
                  backgroundColor: "#69B76F",
                  border: "1px solid transparent",
                  "&:hover": {
                    backgroundColor: "#69B76F",
                  },
                  marginRight: "30px",
                  width: "110px",
                  fontFamily:
                    '-apple-system, "Open Sans", sans-serif !important',
                }}
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteDevicePopup;
